import React, { useMemo } from "react";
import { Page, Text, View, Document, Image, StyleSheet, Svg, Path, Font} from '@react-pdf/renderer';
import { colorStand, colorsTabletops, colorMirror} from "../utils/colors";
import { sumConfig } from '../utils/utils';

import fontLoos from './../assets/fonts/LoosLatinLightWeb.ttf'
import LogoImg from './../assets/img/pdf.png'


Font.register({
    family: 'Loos-light',
    src: fontLoos,
  })


const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      fontFamily: 'Loos-light',
    },
    section: {
      margin: 10,
      padding: 10,
      paddingBottom: 0,
      marginBottom: 0,
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },

    header__img: {
        marginRight: '20%'
    },

    header__info: {
        marginRight: '20%',
        fontFamily: 'Loos-light',
    },
    header__infoItem: {
        textTransform: 'uppercase',
    },

    svg: {
        marginBottom: 10,
    },
    info: {
        fontSize: 14,
    },
    textSection: {
        margin: 10,
        padding: 10,
        marginTop: 10,
        paddingTop: 0,
    },
    img: {
        marginTop: 10,
    },

    table: {
        display: 'flex',
        flexDirection: 'row',
        borderLeft: '1px solid black',
        flexWrap: 'wrap',
        marginBottom: 20,
        fontSize: 12,
    },
    
    tableHead: {
        textAlign: "center",
        display: 'flex',
    },

    tableBody: {
        textAlign: "center",
        borderTop: '1px solid black',
        borderLeft: 'none',
        display: 'flex',
    },

    tableCol: {
        border: '1px solid black',
        borderLeft: 'none',
        flexGrow: '1',
        textAlign: 'center',
    },
    tableText: {
        margin: 'auto'
    },
    title: {
        fontSize: 32,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    img__subtitle: {
        fontSize: 12,
        textAlign: "center",
    },
    line: {
        width: '100%',
        height: 2,
        backgroundColor: 'black',
    },
    sum: {
        fontSize: 32,
        fontWeight: 'bold',
        textAlign: 'right',
    },
    sum__section: {
        margin: 10,
        padding: 10,
        paddingBottom: 0,
        marginBottom: 0,
        marginTop: 0,
    }
});


const searchMaterialStand = (type) => {
    let currentMaterial = ''
    for(let key in colorStand) {
        if(type === key) {
            currentMaterial = colorStand[key][0].name;
        }
    }
    return currentMaterial;
}

const searchMaterialTabletop = (type) =>{
    let currentMaterial = ''
    let currentType = ''
    for(let key in colorsTabletops) {
        const material = colorsTabletops[key].name;
        const materialObj = colorsTabletops[key].type[0];
        for(let key in materialObj) {
            if(key === type) {
                currentMaterial = material;
                currentType = materialObj[key].name;
            }
        }
    }
    return {material: currentMaterial, type: currentType};
}

const searchMaterialMirror = (type) => {
    let currentMaterial = ''
    for(let key in colorMirror) {
        if(type === key) {
            currentMaterial = colorStand[key][0].name;
        }
    }
    return currentMaterial;
}

const Logo = () => (
    <Image style={styles.header__img} src={LogoImg}/>
)

const DocumentComponent = ({canvasRef, code, config, imgSrc}) => {
    const mirrorTableHead = config.mirror === false ? [] : config.mirror.mirror.height === 888 ? ['Зеркало', 'Диаметр', 'Глубина', 'Материал', 'Цвет', 'Артикул', 'Цена'] : ['Зеркало', 'Ширина', 'Высота', 'Глубина', 'Материал', 'Цвет', 'Артикул', 'Цена'];
    const mirrorTableBodyWithWH = config.mirror !== false ?  [`${config.mirror.name}`, `${config.mirror.mirror.width} мм`, `${config.mirror.mirror.height} мм`, `${config.mirror.mirror.depth} мм`, `${config.mirror.wMaterial ? `${searchMaterialMirror(config.mirror.material)}` : '-'}`, `${config.mirror.color ? `${config.mirror.color}` : '-'}`, `${config.mirror.fullArticle}`, `${config.mirror.price} Р`] : []; 
    const mirrorTableBodyWithD = config.mirror !== false ?  [`${config.mirror.name}`, `${config.mirror.mirror.width} мм`, `${config.mirror.mirror.depth} мм`, `${config.mirror.wMaterial ? `${searchMaterialMirror(config.mirror.material)}` : '-'}`, `${config.mirror.color ? `${config.mirror.color}` : '-'}`, `${config.mirror.fullArticle}`, `${config.mirror.price} Р`] : []; 
    const mirrorTableBody = config.mirror !== false ? config.mirror.mirror.height === 888 ? mirrorTableBodyWithD : mirrorTableBodyWithWH : [];

    const sinkTableHead = ['Раковина', 'Ширина', 'Глубина', 'Кол-во чаш', 'Вырез под смеситель', 'Позиция чаш(и)','Донный клапан', 'Тип', 'Артикул', 'Цена'];
    const sinkTableBody = config.sink !== false ? [`${config.sink.name}`,`${config.sink.sink.countertop_width} мм`, `${config.sink.sink.countertop_depth} мм`, `${config.sink.sink.count_cup}`, `${config.sink.cutout ?'Без выреза' : 'С вырезом'}`, `${config.sink.position}`, `${config.sink.flap.name ? config.sink.flap.name : '-'}`, `${config.sink.type}`,`${config.sink.fullArticle}`, `${config.sink.price + (config.sink.position === 'D' ? 2 : 1) * (config.sink.flap ? Number(config.sink.flap.price) : 0)} Р`] : [];
    
    const tabletopTableHead = ['Столешница', 'Глубина', 'Ширина', 'Материал/Тип', 'Цвет', 'Позиция выреза','Кол-во вырезов','Артикул', 'Цена'];
    const tabletopTableBody = config.tabletop !== false ? [`${searchMaterialTabletop(config.tabletop.type).material}`, `${config.stand.stand.depth + 3} мм`,`${config.tabletop.tabletop.width} мм`, `${searchMaterialTabletop(config.tabletop.type).type.replace('Матовая эмаль', 'Керамогранит категории A').replace('Глянцевая эмаль', 'Керамогранит категории B')}`, `${config.tabletop.color ? `${config.tabletop.color}` : '-' }`, `${config.tabletop.position}`, `${config.tabletop.countCup}`, `${config.tabletop.fullArticle}`, `${config.tabletop.price + (config.tabletop.countCup===2 ? 3500 : 0)} Р`] : [];
    
    const standTableHead = ['Тумба', 'Ширина', 'Высота', 'Глубина', 'Материал', 'Цвет', 'Артикул', 'Цена'];
    const standTableBody = config.stand !== false ? [`${config.stand.name}`, `${config.stand.stand.width} мм`, `${config.stand.stand.height} мм`, `${config.stand.stand.depth} мм`, `${searchMaterialStand(config.stand.material)}`, `${config.stand.color}`, `${config.stand.fullArticle}`, `${config.stand.price} Р`] : [];
    if(config.stand.positionStand !== false && config.stand.positionStand !== undefined) {
        let indexToInsert = standTableHead.length - 1;
        let indexToInsertBody = standTableBody.length - 1;
        standTableHead.splice(indexToInsert, 0, 'Вид тумбы');
        standTableBody.splice(indexToInsertBody, 0, `${config.stand.positionStand}`);
    } 

    if(config.stand.secondMaterial!== false && config.stand.secondMaterial !== undefined) {
        let indexToInsert = standTableHead.length - 1;
        let indexToInsertBody = standTableBody.length - 1;
        standTableHead.splice(indexToInsert, 0, 'Второй материал');
        standTableBody.splice(indexToInsertBody, 0, `${searchMaterialStand(config.stand.secondMaterial)}`);
    } 

    if(config.stand.secondColor !== false && config.stand.secondColor !== undefined) {
        let indexToInsert = standTableHead.length - 1;
        let indexToInsertBody = standTableBody.length - 1;
        standTableHead.splice(indexToInsert, 0, 'Второй цвет');
        standTableBody.splice(indexToInsertBody, 0, `${config.stand.secondColor}`);
    } 
    
    

    const cabinetTableHead = ['Пенал', 'Ширина', 'Высота', 'Глубина', 'Материал', 'Цвет', 'Петли', 'Артикул', 'Цена'];
    const cabinetTableBody = config.cabinet ? [`${config.cabinet.name}`, `${config.cabinet.cabinet.width} мм`, `${config.cabinet.cabinet.height} мм`, `${config.cabinet.cabinet.depth} мм`,`${searchMaterialStand(config.cabinet.material)}`, `${config.cabinet.color}`, `${config.cabinet.position}`, `${config.cabinet.fullArticle}`, `${config.cabinet.price} Р`] : [];
    if(config.cabinet.secondMaterial!== false && config.cabinet.secondMaterial !== undefined) {
        let indexToInsert = cabinetTableHead.length - 1;
        let indexToInsertBody = cabinetTableBody.length - 1;
        cabinetTableHead.splice(indexToInsert, 0, 'Второй материал');
        cabinetTableBody.splice(indexToInsertBody, 0, `${searchMaterialStand(config.cabinet.secondMaterial)}`);
    } 

    if(config.cabinet.secondColor !== false && config.cabinet.secondColor !== undefined) {
        let indexToInsert = cabinetTableHead.length - 1;
        let indexToInsertBody = cabinetTableBody.length - 1;
        cabinetTableHead.splice(indexToInsert, 0, 'Второй цвет');
        cabinetTableBody.splice(indexToInsertBody, 0, `${config.cabinet.secondColor}`);
    } 
    let img = canvasRef.current.toDataURL("image/png", 1);

    /*const sum = Number(config.stand ? config.stand.price : 0) + Number(config.mirror ? config.mirror.price : 0) + Number(config.sink ? config.sink.price : 0) + Number(config.tabletop ? config.tabletop.price : 0) + Number(config.cabinet ? config.cabinet.price : 0);*/
    const sum = sumConfig(config);

    //orientation={"landscape"}
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.section}>
                    <View style={styles.header}>
                        <Logo/>
                        <View style={styles.header__info}>
                            <Text style={styles.header__infoItem}>www.mobo.su</Text>
                            <Text style={styles.header__infoItem}>+7 495 487 1287</Text>
                            <Text style={styles.header__infoItem}>zakaz@mobo.su</Text>
                        </View>
                    </View>
                    
                    {img ? <Image style={{marginTop: '10', maxHeight: '600'}} src={imgSrc} /> : ""}
                    <Text style={styles.img__subtitle}>* Изображение является ориентировочным и может не соответствовать реальному размеру и цвету изделий</Text>
                </View>
            </Page>
            <Page size="A4" style={styles.page} >
                <View style={styles.section}>
                    <View style={styles.header}>
                        <Logo/>
                        <View style={styles.header__info}>
                            <Text style={styles.header__infoItem}>www.mobo.su</Text>
                            <Text style={styles.header__infoItem}>+7 495 487 1287</Text>
                            <Text style={styles.header__infoItem}>zakaz@mobo.su</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.textSection}>
                    {
                        standTableBody.length!==0 ? 
                        <>
                            <Text style={styles.title}>Тумба</Text>
                            <View style={styles.table}>
                                {standTableHead.map((mirrorItem, index) => {
                                    return(
                                        <View style={styles.tableCol}>
                                            <View style={{...styles.tableHead}}>
                                                <Text style={styles.tableText}>{mirrorItem}</Text>
                                            </View>
                                            <View style={styles.tableBody}>
                                                <Text style={styles.tableText}>{standTableBody[index]}</Text>
                                            </View>
                                        </View>
                                    )
                                })}
                            </View>
                        </>
                        :
                        <></>
                    }
                    
                    
                    {
                        sinkTableBody.length!==0 ?
                        <>
                            <Text style={styles.title}>Раковина</Text>
                            <View style={styles.table}>
                                {sinkTableHead.map((mirrorItem, index) => {
                                    return(
                                        <View style={styles.tableCol}>
                                            <View style={{...styles.tableHead}}>
                                                <Text style={styles.tableText}>{mirrorItem}</Text>
                                            </View>
                                            <View style={styles.tableBody}>
                                                <Text style={styles.tableText}>{sinkTableBody[index]}</Text>
                                            </View>
                                        </View>
                                    )
                                })}
                            </View>
                        </>
                        :
                        <></>
                    }
                    
                    {
                        tabletopTableBody.length !== 0 ?
                        <>
                            <Text style={styles.title}>Столешница</Text>
                            <View style={styles.table}>
                                {tabletopTableHead.map((mirrorItem, index) => {
                                    return(
                                        <View style={styles.tableCol}>
                                            <View style={{...styles.tableHead}}>
                                                <Text style={styles.tableText}>{mirrorItem}</Text>
                                            </View>
                                            <View style={styles.tableBody}>
                                                <Text style={styles.tableText}>{tabletopTableBody[index]}</Text>
                                            </View>
                                        </View>
                                    )
                                })}
                            </View>
                        </>
                        :
                        <></>
                    }

                    {
                        mirrorTableBody.length !== 0 ?
                        <>
                            <Text style={styles.title}>Зеркало</Text>
                            <View style={styles.table}>
                                {mirrorTableHead.map((mirrorItem, index) => {
                                    return(
                                        <View style={styles.tableCol}>
                                            <View style={{...styles.tableHead}}>
                                                <Text style={styles.tableText}>{mirrorItem}</Text>
                                            </View>
                                            <View style={styles.tableBody}>
                                                <Text style={styles.tableText}>{mirrorTableBody[index]}</Text>
                                            </View>
                                        </View>
                                    )
                                })}
                            </View>
                        </>
                        :
                        <></>
                    }
                    
                    {
                        cabinetTableBody.length !== 0 ?
                        <>
                            <Text style={styles.title}>Пенал</Text>
                            <View style={styles.table}>
                                {cabinetTableHead.map((mirrorItem, index) => {
                                    return(
                                        <View style={styles.tableCol}>
                                            <View style={{...styles.tableHead}}>
                                                <Text style={styles.tableText}>{mirrorItem}</Text>
                                            </View>
                                            <View style={styles.tableBody}>
                                                <Text style={styles.tableText}>{cabinetTableBody[index]}</Text>
                                            </View>
                                        </View>
                                    )
                                })}
                            </View>
                        </>
                        :
                        <></>
                    }
                    

                </View>
                <View style={styles.sum__section}>
                    <View style={styles.line}></View>
                    <Text style={styles.sum}>ИТОГО: {sum} Р</Text>
                </View>
                
            </Page>
        </Document>
    )
}

export default DocumentComponent;